import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Listen for offcanvas show events to load content
    this.element.addEventListener('show.bs.offcanvas', this.onShow.bind(this))

    // Add click handlers to navigation buttons to prevent offcanvas closing
    this.setupNavigationButtons()
  }

  disconnect() {
    this.element.removeEventListener('show.bs.offcanvas', this.onShow.bind(this))
  }

  setupNavigationButtons() {
    // Find all buttons that target this offcanvas
    const buttons = document.querySelectorAll(`[data-bs-target="#${this.element.id}"]`)

    buttons.forEach(button => {
      button.addEventListener('click', this.handleButtonClick.bind(this))
    })
  }

  handleButtonClick(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const tab = button.dataset.sidebarTab
    const title = button.textContent.trim()

    if (tab && title) {
      this.loadContent(tab, title)
    }

    // Manually show the offcanvas
    const offcanvas = new bootstrap.Offcanvas(this.element)
    offcanvas.show()
  }

  onShow(event) {
    // Find which button triggered the offcanvas
    const triggerButton = document.querySelector(`[data-bs-target="#${this.element.id}"]`)
    if (!triggerButton) return

    const tab = triggerButton.dataset.sidebarTab
    const title = triggerButton.textContent.trim()

    if (tab && title) {
      this.loadContent(tab, title)
    }
  }

  loadContent(tab, title) {
    const titleElement = this.element.querySelector('[data-offcanvas-title]')
    const contentElement = this.element.querySelector('[data-offcanvas-content]')
    const baseUrl = this.element.dataset.baseUrl

    if (titleElement) {
      titleElement.textContent = title
    }

    if (contentElement && baseUrl && tab) {
      // Show loading state
      contentElement.innerHTML = `
        <div class="text-center text-muted">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          Loading...
        </div>
      `

      const url = `${baseUrl}/${tab}`

      // Fetch content
      fetch(url, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.text())
      .then(html => {
        contentElement.innerHTML = html
      })
      .catch(error => {
        contentElement.innerHTML = `
          <div class="alert alert-danger">
            Error loading content. Please try again.
          </div>
        `
      })
    }
  }
}